import React, { useEffect, useState } from "react";
import { Table, Typography, Spin, message, Card } from "antd";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useMediaQuery } from "react-responsive"; // <-- Add this import

const { Title } = Typography;

const MyOrders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ maxWidth: 767 }); // <-- Detect mobile

  useEffect(() => {
    checkUserActiveStatus();
    fetchOrders();
    // eslint-disable-next-line
  }, []);

  const checkUserActiveStatus = async () => {
    const tokenString = localStorage.getItem("token");

    try {
      let config = {
        method: "get",
        url:
          global.config.APIURL.BaseURL + "api/UserAccount/GetUserAccountDetail",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + tokenString,
        },
      };

      axios
        .request(config)
        .then((response) => {
          // Redirect to home if AllowtoOrder is false
          if (response.data.AllowtoOrder === false) {
            window.location.href = "/";
            return;
          }

          if (
            response.data.IsActive === false ||
            response.data.IsDeleted === false
          ) {
            alert("Your session has expired. Please log in again.");

            localStorage.removeItem("token");
            localStorage.removeItem("userName");
            window.location.reload();
          }
        })
        .catch((error) => {});
    } catch (error) {}
  };

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const tokenString = localStorage.getItem("token");
      const response = await axios.get(
        global.config.APIURL.BaseURL + "api/Order/GetOrderList",
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + tokenString,
          },
        }
      );
      setOrders(response.data || []);
    } catch (error) {
      message.error("Failed to fetch orders.");
      setOrders([]);
    }
    setLoading(false);
  };

  // Helper for Indian number format with 2 decimals
  const formatINR = (value) =>
    value !== undefined && value !== null
      ? value.toLocaleString("en-IN", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })
      : "0.00";

  // Helper for date format "dd-MM-yyyy"
  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Responsive columns for mobile and desktop
  const columns = isMobile
    ? [
        {
          title: "Order",
          dataIndex: "OrderID",
          key: "OrderID",
          render: (_, record) => (
            <div>
              <div>
                <b>Date:</b> {formatDate(record.OrderDate)}
              </div>
              <div>
                <b>Box:</b> {formatINR(record.TotalBox)}
              </div>
              <div>
                <b>Qty:</b> {formatINR(record.TotalQuantity)}
              </div>
              <div>
                <b>Grand Total:</b>{" "}
                <span style={{ color: "#1890ff" }}>
                  ₹{formatINR(record.GrandTotal)}
                </span>
              </div>
            </div>
          ),
        },
      ]
    : [
        {
          title: "Order Date",
          dataIndex: "OrderDate",
          key: "OrderDate",
          render: (date) => formatDate(date),
        },
        {
          title: "Total Box",
          dataIndex: "TotalBox",
          key: "TotalBox",
          render: (value) => formatINR(value),
        },
        {
          title: "Total Quantity",
          dataIndex: "TotalQuantity",
          key: "TotalQuantity",
          render: (value) => formatINR(value),
        },
        {
          title: "Sub Total",
          dataIndex: "SubAmount",
          key: "SubAmount",
          render: (value) => `₹${formatINR(value)}`,
        },
        {
          title: "GST Amount",
          dataIndex: "GSTAmount",
          key: "GSTAmount",
          render: (value) => `₹${formatINR(value)}`,
        },
        {
          title: "Grand Total",
          dataIndex: "GrandTotal",
          key: "GrandTotal",
          render: (value) => <b>₹{formatINR(value)}</b>,
        },
      ];

  return (
    <div style={{ padding: 0 }}>
      <Card>
        <div
          style={{
            maxWidth: 900,
            margin: isMobile ? "0" : "auto",
            padding: isMobile ? 8 : 16,
          }}
        >
          <Title
            level={2}
            style={{
              marginBottom: 16,
              fontSize: isMobile ? 20 : 28,
              textAlign: isMobile ? "center" : "left",
            }}
          >
            My Orders
          </Title>
          {loading ? (
            <div style={{ textAlign: "center", marginTop: 40 }}>
              <Spin size="large" />
            </div>
          ) : (
            <Table
              columns={columns}
              dataSource={orders}
              rowKey={(record) => record.OrderID}
              locale={{ emptyText: "No orders found." }}
              pagination={false}
              size={isMobile ? "small" : "middle"}
              onRow={(record) => ({
                onClick: () => navigate(`/orderdetail/${record.OrderID}`),
                style: { cursor: "pointer" },
              })}
              scroll={isMobile ? { x: true } : undefined}
            />
          )}
        </div>
      </Card>
    </div>
  );
};

export default MyOrders;
